import React from 'react';
import { Link } from 'react-router-dom';
import VideoModal from '../../components/ModalVideo';
import abimg from '../../images/about5.jpg';
import abimg2 from '../../images/about-shape3.png';
import { useTranslation } from 'react-i18next';

const About4 = () => {
    const { t } = useTranslation(); // Translation hook

    const ClickHandler = () => {
        window.scrollTo(10, 0);
    };

    return (
        <div className="wpo-about-area-s4 section-padding">
            <div className="container">
                <div className="row align-items-center">
                    <div className="col-lg-6 col-md-12 col-sm-12">
                        <div className="wpo-about-img">
                            <img src={abimg} alt="" />
                            <div className="wpo-about-img-text d-flex">
                                <h2>{t('about.years')}</h2>
                                <p>{t('about.experience')}</p>
                                <div className="about-shape">
                                    <img src={abimg2} alt="" />
                                </div>
                            </div>
                            <div className="left-shape">
                                <div className="square-shape"></div>
                                <div className="shape-top">
                                    <span></span>
                                    <span></span>
                                    <span></span>
                                    <span></span>
                                </div>
                                <div className="shape-left">
                                    <span></span>
                                    <span></span>
                                    <span></span>
                                    <span></span>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="col-xl-6 col-lg-6 col-md-12 colsm-12">
                        <div className="wpo-about-text">
                            <div className="wpo-about-title">
                                <span>{t('about.title')}</span>
                                <h2>{t('about.heading')}</h2>
                            </div>
                            <h5>{t('about.subheading')}</h5>
                            <p>{t('about.description')}</p>
                            <div className="btns">
                                <Link to="/about" onClick={ClickHandler} className="theme-btn">
                                    {t('about.discoverMore')}
                                </Link>
                                <ul>
                                    <li className="video-holder">
                                        <VideoModal />
                                    </li>
                                    <li className="video-text">{t('about.introduction')}</li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div className="invisible-title1">
                <h2>{t('about.invisibleTitle')}</h2>
            </div>
        </div>
    );
};

export default About4;
